import { render, staticRenderFns } from "./NavTrac.vue?vue&type=template&id=6f2a2b40&"
import script from "./NavTrac.vue?vue&type=script&lang=ts&"
export * from "./NavTrac.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports